import { authStore } from "@/shared/store/authStore/authStore";
import { AccessEnum } from "@/widgets/Sidebar/types";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import { AccessGuardProps } from "./types";
import { getAccessByPathname } from "@/hooks/useUserAccess";
import { alertHandler } from "@/shared/utils/alertHandler";

export const AccessGuard = ({ children, requiredAccess }: AccessGuardProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const userRole = authStore.state.userInfo?.roleId as AccessEnum;

  useEffect(() => {
    const access = requiredAccess || getAccessByPathname(pathname);
    const hasAccess = access.includes(userRole);

    if (!hasAccess) {
      alertHandler.addAlert({ status: 'warning', defaultText: 'У вас нет прав для просмотра страницы!' });
      router.push('/empty');
    }
  }, [userRole, requiredAccess, router]);
 
  if (!userRole) {
    return <div>Loading...</div>;
  }

  const access = requiredAccess || getAccessByPathname(pathname);
  if (!access.includes(userRole)) {
    return null;
  }

  return <>{children}</>;
};
